import {IntermediatePart} from "../../intermediatePart";

export default class Basket extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'basket';
    this.partName = 'Basket';
    this.translateId = "visualizer.bathroom.basket";
    this.canBeDisabled = true;
  }

}
